import { clearApiCache as clearCache } from './common/clearCache';
import { citiSignOut } from './common/CitiServices';
import { submitWith } from './common/PostBuilder';
import './util/tmx';

const SpeedBumpOverlay = require(`./${process.env.ENTRY_POINT}/SpeedBumpOverlay/SpeedBumpOverlay`).default;

const radio = (app) => {
  app.channel.on('citi-redirects:fusion', async (options) => {
    const CitiRedirects = (await import(/* webpackChunkName: "citi-redirects" */ './citi-redirects'));
    CitiRedirects.SpeedBumpOverlay.init(null, options);
    app.channel.trigger('citi-redirects:speedBumpDone');
  });

  app.channel.on('clear:fusion:cache', async () => {
    const CitiRedirects = (await import(/* webpackChunkName: "citi-redirects" */ './citi-redirects'));
    CitiRedirects.clearCache();
    app.channel.trigger('citi-redirects:clearCacheDone');
  });

  return app;
};

export {
  SpeedBumpOverlay,
  clearCache,
  citiSignOut,
  submitWith,
  radio,
};
